module.exports = __webpack_public_path__ + "img/solar_panel_icon_success.6b204abf.svg";